import * as React from "react";
const SvgFrequency = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 33,
	height: 32,
	viewBox: "0 0 33 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M27.7346 4.8744C24.8801 2.01984 20.9624 0.248047 16.6117 0.248047C7.9102 0.248047 0.88208 7.29586 0.88208 15.9973C0.88208 24.6988 7.9102 31.7466 16.6117 31.7466C23.9548 31.7466 30.0773 26.7266 31.8294 19.9347H27.7346C26.1203 24.5217 21.7499 27.8093 16.6117 27.8093C10.0954 27.8093 4.79972 22.5136 4.79972 15.9973C4.79972 9.48107 10.0954 4.18537 16.6117 4.18537C19.8797 4.18537 22.7933 5.54375 24.9194 7.68959L18.5804 14.0287H32.361V0.248047L27.7346 4.8744Z" }));
export default SvgFrequency;
